import JsonLd from './JsonLd';
import { SITE_URL, SITE_NAME, DEFAULT_DESC, DEFAULT_IMG } from './SEOHead';

/**
 * Site-wide entity schemas for the homepage.
 *
 * Organization → declares JS Fragrance as a verified entity (drives
 *   Knowledge Panel + AI engine confidence).
 * WebSite → enables Google's sitelinks search box for branded queries.
 */
export default function OrganizationSchema() {
  const org = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    alternateName: 'JS Fragrances',
    url: SITE_URL,
    logo: `${SITE_URL}/icons/icon-512x512.png`,
    description: DEFAULT_DESC,
    image: DEFAULT_IMG,
    sameAs: [
      'https://www.facebook.com/profile.php?id=61588041885547',
      'https://www.tiktok.com/@jsfragranceofficial',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Support',
      areaServed: 'PH',
      availableLanguage: ['English', 'Filipino'],
    },
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'PH',
    },
  };

  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/shop?search={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <JsonLd id="organization" data={org} />
      <JsonLd id="website" data={website} />
    </>
  );
}
